import {
  BodyWrapper,
  Caption1,
  Caption2,
  Flex,
  H6,
  Input,
} from '@components/atoms'
import {
  FanTest4DataPopup,
  FanTest4ResultPopup,
  FanTestMelonPopup,
} from '@components/organisms'
import React, { useState } from 'react'
import {
  fantest_description,
  fantest_unis_1,
  fantest_unis_2,
  fantest_unis_3,
  fantest_unis_4,
} from '@images/index'
import styled, { css } from 'styled-components'

import { Image } from '@components/molecules'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { PIXEL_EVENTS } from '@utils/facebook/pixelLogs'
import { STORAGE_URL } from '@consts'
import YouTube from 'react-youtube'
import { colors } from '@colors'
import { handleArtistImgError } from '@utils/handler'
import { pixelTrack } from '@utils/facebook/pixel'

const FanTestEvent4Template = ({ history, authStore }) => {
  const {
    isShowing: openResultPopupIsShowing,
    toggle: openResultPopupToggle,
  } = FanTest4ResultPopup.usePopup()

  const {
    isShowing: openPhonePopupIsShowing,
    toggle: openPhonePopupToggle,
  } = FanTest4DataPopup.usePopup()

  const submitChallenge = () => {
    pixelTrack(PIXEL_EVENTS.덕력고사4.제출)
    if (typeof window.twq === 'function') {
      window.twq('event', 'tw-owc18-pjbre')
    }

    openPhonePopupToggle()
  }

  const requestEvent = async (phone, link) => {
    const result = await authStore.requestFanTestEvent({
      eventTitle: 'EVENT_UNIS_001',
      phoneNumber: phone,
      additionalText: link,
    })
  }

  return (
    <BodyWrapper style={{ padding: 0, minHeight: '100vh' }}>
      <Flex type="column">
        <Flex style={{ position: 'relative', width: '100%' }} type={'column'}>
          <TitleImage src={fantest_unis_1} />
          <StartButton
            onClick={() => {
              window.open(
                'https://www.instagram.com/reels/audio/975353754752817?igsh=NzcxNDEzNHI1Mmlk',
              )
            }}
          >
            <ButtonText color={'#fafafa'}>SWICY 챌린지 시작하기</ButtonText>
          </StartButton>
        </Flex>
        <TitleImage src={fantest_unis_2} />

        <Flex style={{ position: 'relative', width: '100%' }} type={'column'}>
          <TitleImage src={fantest_unis_3} />

          <ButtonContainer align={'center'} style={{}}>
            <SubmitRedButton onClick={submitChallenge}>
              <ButtonText color={'#fafafa'}>챌린지 제출하기</ButtonText>
            </SubmitRedButton>
          </ButtonContainer>
        </Flex>

        <TitleImage src={fantest_unis_4} />
      </Flex>
      <Flex
        style={{
          gap: 8,
          background: '#fff',
          padding: '10px 20px',
          position: 'sticky',
          bottom: 0,
        }}
      >
        <SubmitButton onClick={submitChallenge}>
          <H6 color={'#fafafa'}>챌린지 제출하기</H6>
        </SubmitButton>
      </Flex>

      <FanTest4ResultPopup.View
        isShowing={openResultPopupIsShowing}
        toggle={openResultPopupToggle}
        onOk={() => {}}
      />
      <FanTest4DataPopup.View
        isShowing={openPhonePopupIsShowing}
        toggle={openPhonePopupToggle}
        toggleComplte={openResultPopupToggle}
        requestOpen={requestEvent}
      />
    </BodyWrapper>
  )
}

export default FanTestEvent4Template

const TitleImage = styled.img`
  width: '100%';
  height: 'auto';
`

const Description = styled(Flex)`
  background-image: url(${fantest_description});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative; /* 오버레이를 위해 필요 */

  padding: 28px 20px;
  gap: 3px;

  white-space: pre-line;
  /* 오버레이 추가 */
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(211, 211, 211, 0.5);
    mix-blend-mode: multiply;
    pointer-events: none; /* 클릭 방해 방지 */
  }
`

const SearchImage = styled.img`
  width: 51.6vw; /* 186px */
  max-width: 216px;
  margin: 32px 0 27px 0;
  align-self: center;
  height: auto;
`
const ButtonContainer = styled(Flex)`
  width: calc(100% - 48px);
  height: 40px;

  border: none !important;
  border-bottom: 2px solid #242424 !important;
  background-color: transparent;

  padding: 10px 0px;

  position: absolute;
  bottom: 48px;

  margin: 0px 20px;

  box-sizing: border-box;
`

const StartButton = styled(Flex)`
  display: flex;
  width: calc(100% - 48px);
  height: 52px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #2c1c18;
  box-sizing: border-box;
  position: absolute;
  bottom: 32px;
  margin: 0px 20px;
`

const SubmitRedButton = styled(Flex)`
  display: flex;
  width: 100%;
  height: 52px;
  padding: 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  background: #970718;
  box-sizing: border-box;
`

const HintButton = styled(Flex)`
  width: 96px;
  height: 44px;
  padding: 5.5px 13px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  border: 0.5px solid var(--grey-grey_80, #242424);
  box-sizing: border-box;
  cursor: pointer;
`

const SubmitButton = styled(Flex)`
  flex: 1;
  height: 44px;
  padding: 5.5px 13px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  background: var(--grey-grey_80, #242424);
  box-sizing: border-box;
  cursor: pointer;

  ${props =>
    props.disabled &&
    css`
      pointer-events: none;
      opacity: 0.16;
    `}
`

const YoutubeWrapper = styled(Flex)`
  width: calc(100% - 40px);
  position: relative;
  margin: 0 20px;
  border-radius: 9.97px;
  overflow: hidden;
  position: absolute;
  bottom: 84.47px;
  box-sizing: border-box;
`

const ButtonText = styled.h6`
  width: auto;
  text-align: ${props => (props.align ? props.align : 'center')};
  word-break: keep-all;
  font-weight: 500;
  margin: 0;
  padding: 0;

  font-family: Paperlogy-5Medium;
  color: ${props => props.color};

  font-size: 20px;
  line-height: normal;
`
